import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal, SectionHeader } from "./Reveal";

const FAQS = [
  {
    q: "What is CDM Pay?",
    a: "CDM Pay is a platform for exchanging USDT to INR and managing exchange orders online.",
    testid: "faq-item-1",
  },
  {
    q: "How do I create an exchange order?",
    a: "Log in to your CDM Pay account, enter the exchange details and follow the instructions shown for your order.",
    testid: "faq-item-2",
  },
  {
    q: "How do I receive INR?",
    a: "INR payments are processed through the supported payment/cash deposit instructions associated with your order.",
    testid: "faq-item-3",
  },
  {
    q: "Can I track my order?",
    a: "Yes. Users can view their order status from their CDM Pay account.",
    testid: "faq-item-4",
  },
  {
    q: "Is the exchange rate fixed?",
    a: "The applicable rate should be shown at the time of order creation and may depend on the platform's current rate configuration.",
    testid: "faq-item-5",
  },
  {
    q: "Do I need an account?",
    a: "Yes. Users should log in or register before creating an exchange order.",
    testid: "faq-item-6",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="section-pad relative">
      <div className="container-x relative">
        <SectionHeader
          testid="faq"
          eyebrow="FAQ"
          title="Frequently asked questions"
          sub="Everything you need to know about exchanging USDT to INR on CDM Pay."
        />

        <div className="mx-auto mt-14 max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map(({ q, a, testid }, i) => (
              <Reveal key={q} delay={i * 0.06}>
                <AccordionItem
                  value={`faq-${i}`}
                  data-testid={testid}
                  className="border-white/[0.08]"
                >
                  <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-white hover:text-emerald-300 hover:no-underline sm:text-lg">
                    {q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-400 sm:text-base">
                    {a}
                  </AccordionContent>
                </AccordionItem>
              </Reveal>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
